/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2NotifyAdd/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2NotifyAdd({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2NotifyAdd",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2NotifyAdd.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-ZhahHv': alignSelf,'--mt-2-ZhahHv': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZhahHv': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZhahHv': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZhahHv': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZhahHv': opacity,'--w-10-ZhahHv': typeof width === 'number' ? `${width}px` : width,'--h-11-ZhahHv': typeof height === 'number' ? `${height}px` : height,'--f-12-ZhahHv': fill,'--a-7-ZhahHv': isAnimated ? animation : "none",'--sd-8-ZhahHv': isAnimated ? strokeDashoffset : 0,'--sd-9-ZhahHv': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2NotifyAdd.SvgPath"
  data-view-path={viewPath}
 clipRule="evenodd"
 d="M11.5.75a.75.75 0 00-1.5 0V2.5H8.25a.75.75 0 000 1.5H10v1.75a.75.75 0 001.5 0V4h1.75a.75.75 0 000-1.5H11.5V.75zM6 1.5c.369 0 .733.042 1.086.123A2 2 0 008.25 5.25h.5v.5a2 2 0 001.822 1.992v1.833c0 .234.1.466.289.642.219.204.391.283.639.283a.5.5 0 010 1H.5a.5.5 0 010-1c.248 0 .42-.079.64-.283a.878.878 0 00.288-.642V5.8c0-1.152.49-2.25 1.351-3.053A4.725 4.725 0 016 1.5zM4.25 13.25A.75.75 0 015 12.5h2A.75.75 0 017 14H5a.75.75 0 01-.75-.75z"
 className="views-block"
/>
</svg>
{children}
</React.Fragment>)
}